import axios from 'axios'
import { HOST } from './../constants/url'
import { getQueryString, trimStrings } from '../helper/common'
import { CheckApiKey } from '../helper/CheckApiKey'
import {
  encryptAes256CBC,
  decryptAes256CBC
} from './../pageUtililiy/EncryptionFunctions'

function cleanUp() {
  window.localStorage.clear()
  window.location.href = '/login'
}

function send({
  method = 'get',
  path,
  data = null,
  query = null,
  headers = {},
  newUrl
}) {
  return new Promise((resolve) => {
    const apiKey = CheckApiKey()

    const _query = {
      ...query,
      apiKey
    }

    let url = HOST + `${path}${getQueryString(_query)}`

    if (newUrl) {
      url = `${newUrl}${getQueryString(_query)}`
    }

    let requestData = data
    const runtimeMode = process.env.REACT_APP_RUNTIME_MODE
    const payloadKey = process.env.REACT_APP_KEY_PAYLOAD || ''

    const isPublicApi = path.includes('StationRegistration/public/create')
    if (!isPublicApi && runtimeMode === 'production' && data) {
      const newObj = {}

      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          newObj[payloadKey + key] = data[key]
        }
      }

      requestData = encryptAes256CBC(
        JSON.stringify(trimStrings(newObj))
      )
    }

    axios({
      method,
      url,
      data: requestData,
      headers
    })
      .then((result) => {
        let data = result.data

       if (data?.idEn) {
          data = JSON.parse(decryptAes256CBC(data))
        }

        resolve(data)
      })
      .catch((error) => {
        const result = error?.response?.data || null

        if (!result) {
          return resolve({
            statusCode: 500,
            message: 'Unknown error'
          })
        }

        const { statusCode, message } = result

        if (statusCode === 401) {
          setTimeout(cleanUp, 1000)
        } else if (
          (statusCode === 401 && message === 'Unauthorized') ||
          (statusCode === 403 && message === 'InvalidToken')
        ) {
          cleanUp()
        }

        resolve(result)
      })
  })
}

export default {
  send
}